import type { PresignedPost } from "@aws-sdk/s3-presigned-post";
import type { DocumentTypes } from "@bbj-types/document/enum";
import { useCallback } from "react";
import { axiosSettings } from "./axios";

export type TOtherTemplateType =
  | typeof DocumentTypes.EPT_RENEWAL_TEMPLATE
  | typeof DocumentTypes.EPT_REORIENTATION_TEMPLATE
  | typeof DocumentTypes.FUP_TEMPLATE;

export const usePrepareUploadOtherTemplate = () => {
  const [state, execute, cancel] = axiosSettings<PresignedPost, { name: string }, unknown>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (organisation: string, templateType: TOtherTemplateType, data: { name: string }) => {
      return execute({
        url: `/v2/organisations/${organisation}/template/${templateType}`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
